/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Breakpoint } from 'react-socks';

class EditorButtons extends React.Component {
    render() {
        let saveClass = classnames('btn-primary fixed save-button square',
            this.props.extraButtonClasses,
            {
                'active': this.props.saveActive
            }),
            saveAction = this.props.saveActive ? this.props.saveAction : null,
            componentClass = classnames('editor-buttons', this.props.extraComponentClasses),
            cancelButton = null,
            backToTilesButton = null;

        if (this.props.showCancel) {
            if (this.props.stepLabel !== '') {
                cancelButton = (
                    <div className="cancel-button">
                        {this.props.stepLabel}
                    </div>
                );
            } else {
                cancelButton = (
                    <div className="cancel-button" onClick={this.props.cancelAction} role="button" aria-label="cancel">
                        cancel
                    </div>
                );
            }
        }

        if (this.props.backAction) {
            backToTilesButton = (
                <div className="choose-new-type">
                    <a href="#" onClick={this.props.backAction}>
                        {"< Back"}
                    </a>
                </div>
            );
        }

        return (
            <div className={componentClass}>
                <Breakpoint desktop only>
                    {backToTilesButton}
                </Breakpoint>
                {cancelButton}
                {this.props.showSave ? (
                    <div className={saveClass} onClick={saveAction} role="button" aria-label="continue/save">
                        {this.props.saveLabel}
                    </div>
                ) : null}
                <Breakpoint mobile only>
                    {backToTilesButton}
                </Breakpoint>
            </div>
        );
    }

};

EditorButtons.displayName = "EditorButtons";

EditorButtons.propTypes = {
    stepLabel: PropTypes.string,
    showCancel: PropTypes.bool,
    cancelAction: PropTypes.func,
    extraComponentClasses: PropTypes.string,
    extraButtonClasses: PropTypes.string,
    saveActive: PropTypes.bool,
    saveAction: PropTypes.func,
    saveClass: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    showSave: PropTypes.bool
};

EditorButtons.defaultProps = {
    stepLabel: '',
    showCancel: true,
    cancelAction: null,
    saveActive: false,
    saveAction: null,
    saveLabel: '',
    showSave: true
};

export default EditorButtons;
